import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { SwiperConfig } from '../../shared/directive/swiper.directive';

@Component({
    selector: 'app-main-carousel',
    templateUrl: './main-carousel.component.html',
    styleUrls: ['./main-carousel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MainCarouselComponent implements OnInit {
  @Input('slides') slides: Array<any> = [];
  public config: SwiperConfig = {};
  private pagination: SwiperConfig['pagination'] = {
    el: '.swiper-pagination',
    clickable: true
  };
  constructor() { }
  ngOnInit() {  
  }
  ngAfterViewInit(){
    this.config = {
      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: 5,
      keyboard: true,
      navigation: true,
      pagination: this.pagination,
      grabCursor: true,
      loop: false,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      speed: 500,
      effect: "slide"
    }
  }
}
